import React from 'react';
import Domestic from './Domestic';
import Exports from './Exports';
import { Box } from '@mui/material';
interface IProps {
  apiData: any;
  year: number;
}
const Type = ({ apiData, year }: IProps) => {
  const { totalOfDomesticPerMonth, totalOfExportsPerMonth } = apiData;
  return (
    <div style={{ display: 'flex' }}>
      <Domestic totalOfDomesticPerMonth={totalOfDomesticPerMonth} year={year} />

      {<Exports totalOfExportsPerMonth={totalOfExportsPerMonth} year={year} />}
    </div>
  );
};

export default Type;
